import Header from "../components/Header";
import Footer from "../components/Footer";

const SECTIONS = [
  {
    h: "1. Introduction",
    p: [
      "oly Inbox (\"we\", \"us\") respects your privacy. This Privacy Policy explains what personal information we collect, how we use it, who we share it with, and the choices you have. It applies to olyinbox.com and the oly Inbox email-forwarding service.",
    ],
  },
  {
    h: "2. Information we collect",
    p: [
      "Account information: your name, email address, and password hash (we never store plaintext passwords; we use bcrypt).",
      "Billing information: Stripe handles all payment data. We store only a Stripe customer ID, subscription ID, and the last-4 digits of your card as returned by Stripe.",
      "Domain information: domains you connect, Mailgun verification state, DNS records, and alias configurations.",
      "Usage data: timestamps of login, domain/alias CRUD actions, and aggregated deliverability statistics from Mailgun (accepted/delivered/failed counts per alias).",
      "Device & analytics: on the marketing site, Google Analytics 4 collects anonymized, aggregated visit data (page views, referrers, country). IP addresses are truncated before storage. No GA4 is loaded inside the logged-in dashboard.",
    ],
  },
  {
    h: "3. What we do NOT collect",
    p: [
      "We do not store the content of your emails. Messages pass through Mailgun's routing infrastructure and are forwarded to your destination mailbox in real time. We do not keep copies on oly Inbox servers.",
      "We do not sell or rent your personal information to third parties.",
    ],
  },
  {
    h: "4. How we use your information",
    p: [
      "To provide the Service (route your email, verify your domains, bill you), communicate about your account (receipts, security alerts, product updates), improve deliverability, and prevent abuse.",
    ],
  },
  {
    h: "5. Sub-processors",
    p: [
      "We use the following processors:",
      "· Mailgun (email routing and deliverability) — https://www.mailgun.com/privacy-policy/",
      "· Stripe (payments) — https://stripe.com/privacy",
      "· MongoDB Atlas (application database) — https://www.mongodb.com/legal/privacy-policy",
      "· Google Analytics 4 (marketing-site analytics only) — https://policies.google.com/privacy",
    ],
  },
  {
    h: "6. Data retention",
    p: [
      "We retain account and billing records for the life of your account plus 7 years for tax/accounting purposes. On account deletion we remove Mailgun routes within 30 days and anonymize alias/domain records after 90 days.",
    ],
  },
  {
    h: "7. Your rights",
    p: [
      "You can access, correct, export, or delete your personal data at any time by emailing support@olyinbox.com. If you are in the EU/UK, you have GDPR rights (access, rectification, erasure, restriction, portability, objection). If you are in California, you have CCPA/CPRA rights. We respond within 30 days.",
    ],
  },
  {
    h: "8. Security",
    p: [
      "We encrypt data in transit (TLS 1.2+) and at rest. Passwords are bcrypt-hashed. Webhook signatures are verified. Admin access is 2-factor-gated on our infrastructure. No system is 100% secure; we work hard to protect yours.",
    ],
  },
  {
    h: "9. Cookies",
    p: [
      "We use two httpOnly session cookies (access_token, refresh_token) to keep you logged in. These are Secure, SameSite=Lax, and cleared on logout. The marketing site uses a single GA4 cookie (_ga) only on olyinbox.com.",
    ],
  },
  {
    h: "10. Children's privacy",
    p: [
      "oly Inbox is not directed to children under 13. We do not knowingly collect personal information from children. If you believe we have, email support@olyinbox.com for deletion.",
    ],
  },
  {
    h: "11. International transfers",
    p: [
      "Your data may be processed in the United States where our sub-processors operate. We rely on Standard Contractual Clauses where required.",
    ],
  },
  {
    h: "12. Changes to this policy",
    p: [
      "We may update this Privacy Policy from time to time. Material changes will be emailed to the address on file at least 14 days before taking effect.",
    ],
  },
  {
    h: "13. Contact",
    p: [
      "Questions, requests, or complaints: support@olyinbox.com. For privacy-specific matters please put \"Privacy\" in the subject line.",
    ],
  },
];

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-3xl mx-auto px-6 lg:px-8 py-16" data-testid="privacy-page">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#F26953] mb-3">Legal</div>
        <h1 className="text-4xl sm:text-5xl font-bold text-[#0F172A] tracking-tight">Privacy Policy</h1>
        <p className="text-sm text-[#475569] mt-3">Last updated: April 22, 2026</p>

        <div className="mt-10 space-y-8">
          {SECTIONS.map((s) => (
            <section key={s.h}>
              <h2 className="text-lg font-bold text-[#0F172A]">{s.h}</h2>
              {s.p.map((para, i) => (
                <p key={i} className="mt-3 text-sm leading-relaxed text-[#475569]">{para}</p>
              ))}
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
